<script setup lang="ts">
import { computed } from 'vue';
import { Step, StepType } from '@/dashboard/types/step';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import { CreateEditPopupType } from '@/dashboard/vue/components/popups/CreatePopupTabs/types';

const props = defineProps<{
  tabs: CreateEditPopupType[];
  showTeam: boolean;
  currentStep: StepType;
  stepChanged: (step: StepType) => void;
}>();
const tabs = computed(() => {
  if (!props.showTeam) {
    return props.tabs.filter((tab) => tab.step !== Step.Team);
  }
  return props.tabs;
});
</script>

<template>
  <div class="mb-[55px] mt-[48px] flex w-[488px] flex-col">
    <div class="ml-[28px] flex h-[56px] gap-[33px]">
      <button v-for="(tab, index) in tabs" :key="index" class="flex flex-col pt-[4px]" @click="() => props.stepChanged(tab.step)">
        <span class="text-content-l flex flex-1 items-center text-black dark:text-gray-500">{{ tab.title }}</span>
        <span class="relative bottom-[-1px] flex h-[3px] w-full" :class="{ 'bg-brand-night-blue': props.currentStep === tab.step }"></span>
      </button>
    </div>

    <Divider class="divider-gray-450 dark:divider-gray-750 w-full" />
  </div>
</template>
